/*

  Quick JS by Jason @ freakdesign.
  Questions? Ping me on twitter: @freakdesign

  Relates to blog post:
  https://freakdesign.com.au/blogs/news/get-shipping-estimates-on-a-product-page

  Example:
  https://jasons-experiments.myshopify.com/products/alex-twill-pant-mariner

*/
(function(){

	"use strict";

	/* In case you want to output a bunch of things to the debug console */
	var debug = false;
	var cartCookie;

  var shippingCalcExist = document.querySelector('.shipping-calc-wrapper');
	if(shippingCalcExist) return;

	/* The ID of the element that you want to add the shipping fields into */
  var productSection = document.querySelector('.shopping-calculator');
	if(!productSection){ log('Could not find the element'); return }

	/* the main product select element */
	var productSelect = document.querySelector('.product-form form input[name="id"]');
	var productPrice = document.querySelector('product-data .c-product__details .c-product__prices .c-product__price')?.textContent.replace('R$', '').replace(',', '.').trim();

	var iconButton = '<svg class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M15 8.25H5.8725L10.065 4.0575L9 3L3 9L9 15L10.0575 13.9425L5.8725 9.75H15V8.25Z" fill="#101010" stroke="#101010"/></svg>';

	if(!productSelect){ log('Could not find the main select element'); return }
	var shippingCountry = document.createElement('select');
	var shippingProvince = document.createElement('select');

	var iconButton = '<svg aria-hidden="true" role="img" aria-labelledby="shipping-button" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><title id="shipping-button">Calcular frete</title><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg>';

	var shippingFormStructure = `
		<div class="shipping-calc-wrapper">
			<div class="shipping__title-and-link">
				<label for="shipping-calculator-input" class="title-calc">${window.shippingCalculator.shippingEstimatorTitle}</label>
				<a target="_blank" class="link-code" href="https://buscacepinter.correios.com.br/app/endereco/index.php">Não sei meu CEP</a>
			</div>
			<form class="shipping__input-and-button">
				<input value='' id="shipping-calculator-input" type="text" name="shipping_address[zip]" placeholder="Insira seu CEP" />
				<button class="button shippingCalcButton button--primary">${iconButton}</button>
			</form>
			<p class="message"></p>
		</div>
	`

	/* add to the page */
	productSection.innerHTML = shippingFormStructure;

	var shippingZip = document.querySelector('#shipping-calculator-input');
	var shippingCalcButton = document.querySelector('.shippingCalcButton');
	var shippingMessage = document.querySelector('.shipping-calc-wrapper .message');

	/* We are just adding some dummy fields for example only. There's better ways to handle this */
	var initFields = function(){

		/* create the country picker */
		var countries = ['Brazil'];
		for (var i = 0; i < countries.length; i++) {
			shippingCountry.add(new Option(countries[i], countries[i], i===0));
		};
		shippingCountry.name = 'shipping_address[country]';

		/* create the province state picker */

		var provinces = ['Acre'];
		for (var i = 0; i < provinces.length; i++) {
			shippingProvince.add(new Option(provinces[i], provinces[i], i===0));
		};
		shippingProvince.name = 'shipping_address[province]';

		shippingCalcButton.onclick=function(event){
			event.preventDefault();
			shippingMessage.innerHTML = '';
			if(!productSelect.value.length){ return false }
			if(shippingZip.value != ''){
				shippingCalcButton.innerHTML = '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>';

				shippingCalcButton.setAttribute("disabled", true);
			}
			cartCookie = getCookie('cart');
			var tempCookieValue = tempCookieValue || "temp-cart-cookie___" + Date.now();
			var fakeCookieValue = fakeCookieValue || "fake-cart-cookie___" + Date.now();

			/* if not found, make a new temp cookie */
			if(!cartCookie){ 
				log('no cookie found');
				updateCartCookie(tempCookieValue);
				cartCookie = getCookie('cart');
			}else{
				log('cookie found');
			}

			/* if found but has a weird length, bail */
			if(cartCookie.length < 32){ log('cart ID not valid');return }

			/* Change the cookie value to a new 32 character value */
			updateCartCookie(fakeCookieValue);
			log(getCookie('cart'));

			getRates(parseInt(productSelect.value));
			return false;
		};

	};
	/* A console logging function */
	function log (a){
		if(!debug){ return }
		console.log(a);
	};

	/* get cookie by name */
	var getCookie = function(name) {
		var value = "; " + document.cookie;
		var parts = value.split('; '+name+'=');
		if (parts.length == 2) return parts.pop().split(";").shift();
	};

	/* update the cart cookie value */
	var updateCartCookie = function(a) {
		log('changing cart cookie value to: '+a);
		var date = new Date();
		date.setTime(date.getTime()+(14*86400000));
		var expires = '; expires='+date.toGMTString();
		document.cookie = 'cart='+a+expires+'; path=/';
	};

	/* reset the cart cookie value */
	var resetCartCookie = function(){
		updateCartCookie(cartCookie);
		log(getCookie('cart'));
	};

	/* get the rates */
	var getRates = function(variantId){
		/* add whatever sanity checks you need in addition to the one below */
		if(typeof variantId === 'undefined'){ return }

		/* the main quantity element */
		var productQuantity = document.querySelector('.quantity__input');

		var quantity = productQuantity ? parseInt(productQuantity.value):1;
		var addData = {
			'id':variantId,
			'quantity':quantity
		};

		var totalValue = quantity * Number(productPrice);

		const getShipingButton = document.querySelector('.shippingCalcButton');

		fetch('/cart/add.js', {
			body: JSON.stringify(addData),
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
			},
			method: 'POST'
		}).then(function(response) {
			return response.json();
		}).then(function(json) {
			/* we have JSON */
			//console.log(json);
			/* Change the cookie value back to what it was */

			fetch('/cart/shipping_rates.json?' + new URLSearchParams({
				'shipping_address[country]':shippingCountry.value,
				'shipping_address[province]':shippingProvince.value,
				'shipping_address[zip]':shippingZip.value
			})).then(function(response) {
				return response.json();
			}).then(function(result) {

				const shippingValuesArray = result?.shipping_rates?.map(item => +item.price);
      	const indexMinValue = shippingValuesArray?.indexOf(Math.min(...shippingValuesArray));

				if(result.shipping_rates && result.shipping_rates.length){
					let messageHtml = '<ul>'

					result.shipping_rates?.filter(e => !e.name?.includes('Stanley')).map((element, index) => {
						if (element.delivery_days.length > 0) {
							if (element.delivery_days[0] == 1) {
								var deliveryDays = '<span>1 dia útil</span>'
							} else {
								var deliveryDays = `<span>${element.delivery_days[0]} dias úteis</span>`
							}
						}

						const finalMessage = element.price === "0.00" || (totalValue > 350 && index === indexMinValue) ? `<span>${element.name} com </span><span style="color: #A30817; font-weight: 600;">${theme.strings.shippingCalculator.freeShipping}</span>` : `${element.name} por R$ ${element.price.replace('.', ',')}`

						messageHtml += `
						<li>
							${finalMessage}
							<br>
							${deliveryDays?deliveryDays:''}
						</li>
						`;
						if (index === result.shipping_rates.length) {
							messageHtml += '</ul>'
						}
					})
					shippingMessage.innerHTML = messageHtml;
					getShipingButton.innerHTML = iconButton;
					getShipingButton.removeAttribute("disabled");
				} else {
					shippingMessage.className = 'message error'
					shippingMessage.innerHTML = window.shippingCalculator.shippingEstimatorMessageError;
					getShipingButton.innerHTML = iconButton;
					getShipingButton.removeAttribute("disabled");
				}
				resetCartCookie()
			}).catch(function(error) {
				resetCartCookie();
				shippingMessage.innerHTML = '';
				getShipingButton.innerHTML = iconButton;
				getShipingButton.removeAttribute("disabled");
				console.error('Unable to calculate shipping: ', error)
			})
		}).catch(function(err) {
			/* uh oh, we have error. */
			console.error(err);
			resetCartCookie()
		});

	};

	initFields();
})()